interface PlaceholderProps {
  title: string;
  week: string;
  standalone?: boolean;
}

export function Placeholder({ title, week, standalone = false }: PlaceholderProps) {
  return (
    <section
      className={[
        "flex flex-col items-center justify-center text-center",
        standalone ? "min-h-screen px-6" : "min-h-[calc(100vh-12rem)] px-4",
      ].join(" ")}
      style={{ color: "#1A1620" }}
    >
      <h1 className="font-display text-4xl" style={{ color: "#8A4E9C" }}>
        {title}
      </h1>
      <p className="mt-3 text-base" style={{ color: "#9A8A78" }}>
        Coming in {week}.
      </p>
    </section>
  );
}
